"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_SCRIPTLET_VERSION = exports.ENVIRONMENTS = exports.DEFAULT_URL = exports.DEFAULT_CONFIG = void 0;
var ENVIRONMENTS = {
  staging: 'STAGING',
  prod: 'PRODUCTION'
};
exports.ENVIRONMENTS = ENVIRONMENTS;
var DEFAULT_URL = {
  STAGING: 'https://cosmos.stgairasia.com/xsell/v1/contextualsearch/products',
  PRODUCTION: 'https://cosmos.airasia.com/xsell/v1/contextualsearch/products'
};
exports.DEFAULT_URL = DEFAULT_URL;
var DEFAULT_CONFIG = {
  consumerId: '1',
  locale: 'en-gb',
  geoid: 'MY',
  currency: 'USD',
  viewport: 'desktop',
  userID: null,
  location: {
    country: 'MY',
    nearestAirport: 'KUL',
    city: 'Kuala Lumpur'
  },
  product: 'flights'
};
exports.DEFAULT_CONFIG = DEFAULT_CONFIG;
var MIN_SCRIPTLET_VERSION = '1.2.0';
exports.MIN_SCRIPTLET_VERSION = MIN_SCRIPTLET_VERSION;